import Vue from 'vue'
import VueResource from 'vue-resource'
import Router from 'vue-router'
import Homepage from '@/views/Homepage'
import Post from '@/views/Post'

Vue.use(Router)
Vue.use(VueResource)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage
    },
    {
      path: '/post/:id',
      name: 'post',
      component: Post,
      props: (route) => ({
        id: route.params.id
      })
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js